  <script>
import { mapState } from 'vuex'

export default {
  name: "DoYouHaveADisability",
  props: {
    prepare: {
      type: Boolean,
      default: false
    },
    customProps: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      loading: null,
      validations: {
        validBirthYear: false,
        validState: false,
        inTimeZone: false
      }
    }
  },

  computed: {
    ...mapState([
      'fields',
      'fieldsFromUrl',
      'fieldsFromStorage'
    ])
  },
  created() {
    this.answers = {
      'Yes' : [
        { field: 'disability', value: 'yes' },
        { field: 'disability_0_1', value: 1 },
        { field: 'disability_t_f', value: 'true' },
      ],
      'No' : [
        { field: 'disability', value: 'no' },
        { field: 'disability_0_1', value: 0 },
        { field: 'disability_t_f', value: 'false' },
      ]
    }

    const valueFromUrl = this.fieldsFromUrl['disability']
    if (Object.keys(this.answers).includes(valueFromUrl)) {
      this.setAnswer(valueFromUrl)
    } else {
      const valueFromStorage = this.fieldsFromStorage['disability']
      if (Object.keys(this.answers).includes(valueFromStorage)) {
        this.setAnswer(valueFromStorage)
        return
      }

      this.$emit('show-this-step')
    }

  },
  methods: {
    async setAnswer(answer) {
      this.loading = answer
      await this.$store.dispatch('setAnswers', this.answers[answer])
      this.$emit('next-step')
    },
  }
}
</script>

<template>
  <div v-if="!prepare">
    <div class="container is-max-widescreen px-5">
      <div class="has-text-centered item-box">
        <h2 class="question mb-3">Do you have a disability that prevents you from working?</h2>
        <div class="disability-text-wrapper mb-3">
          <p class="disability-subtext-info">
            If yes, you may qualify for up to $3,148 per month in social security
            disability benefits. National Disability has helped over 50,000 Americans just
            like you apply for and receive benefits. Click yes now to find out if you
            qualify. There is no cost to you! We only get paid if you win your benefits.
          </p>
        </div>
        <div class="answers-box">
          <b-button
            class="answer-button"
            :loading="loading === 'yes'"
            :disabled="loading !== null"
            @click="setAnswer('Yes')"
          >
            Yes
          </b-button>
          <b-button
            class="answer-button"
            :loading="loading === 'no'"
            :disabled="loading !== null"
            @click="setAnswer('No')"
          >
            No
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.disability-text-wrapper {
  margin: 0 auto;
  max-width: 450px;
  .disability-subtext-info {
    color: #A9A9A9;
    font-size: 12px;
  }
}
</style>